import { createAction, props } from '@ngrx/store';
import { AuthUser, LoginResponse, Function } from '@/app/pages/auth/models/auth.model';
import * as AuthActionTypes from './auth.action-types';
import { ApiResponse } from '@app/core/models';
import { Menu } from '@/app/pages/menu-system/models/menu.model';
import { Service } from '@/app/pages/locations/models/service.model';

// Login Actions
export const login = createAction(
  AuthActionTypes.AUTH_LOGIN,
  props<{
    email: string;
    password: string;
    rememberMe: boolean;
    branchId?: number;
    branchCode?: string;
  }>(),
);
export const loginSuccess = createAction(
  AuthActionTypes.AUTH_LOGIN_SUCCESS,
  props<{ response: ApiResponse<LoginResponse[]> }>(),
);
export const loginFailure = createAction(
  AuthActionTypes.AUTH_LOGIN_FAILURE,
  props<{ error: string }>(),
);
export const setMenus = createAction(AuthActionTypes.SET_SERVICES, props<{ menus: Menu[] }>());
//27/12/2025
export const setServices = createAction(AuthActionTypes.SET_SERVICES, props<{ services: Service[] }>());

// Logout Actions
export const logout = createAction(AuthActionTypes.AUTH_LOGOUT);
export const logoutSuccess = createAction(AuthActionTypes.AUTH_LOGOUT_SUCCESS);

// Permissions Actions
export const loadPermissions = createAction(
  AuthActionTypes.AUTH_LOAD_PERMISSIONS,
  props<{ permissions: Function[] }>(),
);

export const loadPermissionsSuccess = createAction(
  AuthActionTypes.AUTH_LOAD_PERMISSIONS_SUCCESS,
  props<{ permissions: Function[] }>(),
);
export const loadPermissionsFailure = createAction(
  AuthActionTypes.AUTH_LOAD_PERMISSIONS_FAILURE,
  props<{ error: string }>(),
);

// Initialize & Storage Actions
export const initializeAuth = createAction(AuthActionTypes.AUTH_INITIALIZE);

export const setAuthUserFromStorage = createAction(
  AuthActionTypes.AUTH_SET_FROM_STORAGE,
  props<{ user: AuthUser }>(),
);

// Refresh User Info Actions
export const refreshUserInfo = createAction(
  AuthActionTypes.AUTH_REFRESH_USER,
  props<{ userId?: number; loginName?: string }>(),
);
export const refreshUserInfoSuccess = createAction(
  AuthActionTypes.AUTH_REFRESH_USER_SUCCESS,
  props<{ user: AuthUser; menus: Menu[]; functions: Function[] }>(),
);
export const setAccessTokenToStore = createAction(
  AuthActionTypes.AUTH_SET_TOKEN,
  props<{ access_token: string }>(),
);

// Utility Actions
export const setLoading = createAction(
  AuthActionTypes.AUTH_SET_LOADING,
  props<{ isLoading: boolean }>(),
);
export const clearError = createAction(AuthActionTypes.AUTH_CLEAR_ERROR);
